import { Reducer } from "redux";

import { ActionType } from "store/types";

import { IUserState, UserActionTypes } from "./user.types";

export const initialState: IUserState = {
  isLoaded: false,
  data: undefined,
};

const reducer: Reducer<IUserState, UserActionTypes> = (
  state: IUserState = initialState,
  action: UserActionTypes
) => {
  switch (action.type) {
    case ActionType.SetUserData:
      const {
        payload: {
          id,
          type,
          email,
          forenames,
          surname,
          performerAccessType,
          agencyList,
          restrictAccess,
        },
      } = action;

      return {
        ...state,
        isLoaded: true,
        data: {
          id,
          type,
          email,
          forenames,
          surname,
          performerAccessType,
          agencyList,
          restrictAccess,
        },
      };
    default:
      return state;
  }
};

export default reducer;
